import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class PhotosBannerController extends Controller {
  connect() {
    const path = window.location.pathname;

    if (path.includes('/photo/')
       || path.includes('/photos')
       || path.includes('/newest-photos')
       || path.includes('content_type=photo')) {
      this.setDismissCookie();
    } else {
      this.element.classList.remove('is-hidden');
    }
  }

  close() {
    triggerCustomEvent(events.photos_banner.photos_banner_dismissed);
    this.setDismissCookie();
    this.element.classList.add('is-hidden');
  }

  learnMore() {
    triggerCustomEvent(events.photos_banner.photos_banner_learn_more);
    this.setDismissCookie();
  }

  setDismissCookie() {
    Cookies.set('photos_banner_dismissed', true);
  }
}
